import React, { useRef, useState, useEffect } from "react";
import { FormGroup, FormControl, ControlLabel, Button, Glyphicon, Dropdown, MenuItem } from "react-bootstrap";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import locale from "../../../../../locale";
import SettingTabWrapper from "../../../Widgets/components/SettingTabWrapper";
import RichEditor from "../../../../RichEditor";

const placeHolderTips = [
    {
        placeholder: "{{userEmail}}",
        tip: "почта зарегистрированного участника"
    },
    {
        placeholder: "{{userName}}",
        tip: "имя зарегистрированного участника"
    },
    {
        placeholder: "{{eventName}}",
        tip: "название мероприятия",
    },
    {
        placeholder: "{{timeStart}}",
        tip: "время начала мероприятия",
    },
    {
        placeholder: "{{timeStop}}",
        tip: "время окончания мероприятия",
    },
    {
        placeholder: "{{dateStart}}",
        tip: "дата начала мероприятия",
    },
    {
        placeholder: "{{dateStop}}",
        tip: "дата окончания мероприятия",
    },
]

export default ({ block, blockProperties, onSave, onSaveFile, onUpdateBlockProperties }) => {
    const [lang, setLang] = useState("ru");
    const imageInputRef = useRef(null);
    const textRuInputRef = useRef('');
    const textEnInputRef = useRef('');

    return (
        <div>
            <FormGroup>
                <FormControlLanguage
                    type="text"
                    values={{
                        ru: blockProperties.titleRu,
                        en: blockProperties.titleEn,
                    }}
                    onChange={{
                        ru: (e) => onUpdateBlockProperties({ titleRu: e.target.value }),
                        en: (e) => onUpdateBlockProperties({ titleEn: e.target.value }),
                    }}
                    onBlur={() => onSave({ titleRu: blockProperties.titleRu, titleEn: blockProperties.titleEn })}
                />
            </FormGroup>

            <Dropdown id="lang" style={{ marginBottom: '20px' }}>
                <Dropdown.Toggle>
                    Текст [{lang}]
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {
                        ['ru', 'en'].map((item) => (
                            <MenuItem
                                key={item}
                                onClick={() => setLang(item)}
                            >
                                Текст [{item}]
                            </MenuItem>
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>

            <FormGroup style={{ minHeight: 365 }}>
                {lang === "ru" ? (
                    <RichEditor
                        key="textRu"
                        value={block.textRu}
                        onChange={(e) => {textRuInputRef.current = e.editor.getData()}}
                        onBlur={() => onSave({ textRu: textRuInputRef.current })}
                    />
                ) : (
                    <RichEditor
                        key="textEn"
                        value={block.textEn}
                        onChange={(e) => {textEnInputRef.current = e.editor.getData()}}
                        onBlur={() => onSave({ textEn: textEnInputRef.current })}
                    />
                )}
            </FormGroup>

            <SettingTabWrapper
                label="Placeholder Tips"
                title={locale('settings.placeholderTips')}
                styles={{ margin: "1rem 0" }}
            >
                {placeHolderTips.map(({ placeholder, tip }, idx) => (<p key={idx}><b>{placeholder}</b> - <>{tip}</></p>))}
            </SettingTabWrapper>
            <FormGroup>
                <ControlLabel>Добавить изображение</ControlLabel>
                {block.imageUrl && <div><img src={block.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                <div>
                    <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                    {' '}
                    {block.imageUrl && <Button onClick={() => onSaveFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                </div>
                <FormControl
                    type="file"
                    onChange={(e) => onSaveFile('image', e.target.files[0] || null)}
                    inputRef={ref => imageInputRef.current = ref}
                    style={{ display: 'none' }}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>Цвет фона</ControlLabel>
                <FormControl
                    type="color"
                    value={'#' + blockProperties.backgroundColor}
                    onChange={(e) => onUpdateBlockProperties({ backgroundColor: e.target.value.replace('#', '') })}
                    onBlur={(e) => onSave({ backgroundColor: blockProperties.backgroundColor })}
                // disabled={isSaving}
                />
            </FormGroup>
        </div>
    )
};
